import { Promise as Promise$1 } from 'rsvp';
import '@ember/runloop';
import '@ember/application';
import '@ember/service';
import '../animate.js';
import '@ember/array';
import '@ember/object/internals';
import '../constraints.js';
import '../mutation-observer.js';
import '../velocity-ext.js';

// This is what we run when no animation is asked for. It just sets
// the newly-added element to visible (because we always start them
// out invisible so that transitions can control their initial
// appearance).
function defaultTransition() {
  if (this.newElement) {
    this.newElement.style.visibility = '';
  }
  return Promise$1.resolve();
}

export { defaultTransition as default };
//# sourceMappingURL=default.js.map
